import { Area } from "./modules/Area";
import "./style.css";
new Area();
